module.exports = __webpack_public_path__ + "img/bussiness_mobile_xmwl.c196fd01.png";